"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OrgLcenseController", {
    enumerable: true,
    get: function() {
        return OrgLcenseController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _orglcenseservice = require("~/services/org-lcense.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let OrgLcenseController = class OrgLcenseController {
    async licenseGet() {
        return await this.orgLcenseService.licenseGet();
    }
    async licenseSet(body) {
        await this.orgLcenseService.licenseSet({
            key: body.key
        });
        return {
            msg: 'The license key has been saved'
        };
    }
    constructor(orgLcenseService){
        this.orgLcenseService = orgLcenseService;
    }
};
_ts_decorate([
    (0, _common.Get)('/api/v1/license'),
    (0, _extractidsmiddleware.Acl)('licenseGet', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], OrgLcenseController.prototype, "licenseGet", null);
_ts_decorate([
    (0, _common.Post)('/api/v1/license'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('licenseSet', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgLcenseController.prototype, "licenseSet", null);
OrgLcenseController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _orglcenseservice.OrgLcenseService === "undefined" ? Object : _orglcenseservice.OrgLcenseService
    ])
], OrgLcenseController);
